export const translations = {
  de: {
    nav: {
      home: "Startseite",
      services: "Leistungen",
      references: "Referenzen",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Projekt anfragen",
    },
    hero: {
      overline: "Elektroplanung · Elektrotechnik · Remote Engineering",
      lines: ["Professionelle", "Elektroplanung für", "Bauprojekte in Deutschland"],
      sub: "Zuverlässige Planung, technische Dokumentation und digitale Unterstützung für Architekturbüros, Ingenieurbüros, Bauunternehmen und Projektentwickler.",
      primary: "Projekt anfragen",
      secondary: "Unsere Referenzen",
      meta: ["Remote Engineering für den deutschen Markt", "Planung nach deutschen Projektstandards", "CAD / BIM basierte Arbeitsweise"],
    },
    marquee: ["Elektroplanung", "Ausführungsplanung", "Starkstrom", "Schwachstrom", "Beleuchtungsplanung", "CAD & BIM", "Technische Dokumentation", "Remote Engineering"],
    sections: {
      services: { index: "02", label: "Leistungen", title: "Unsere Leistungen", sub: "Planung, Dokumentation und technische Unterstützung für Bauprojekte jeder Größenordnung." },
      why: { index: "03", label: "Warum wir", title: "Warum ArStudio Elektro?", sub: "Ein zuverlässiger Planungspartner für den deutschen Baumarkt." },
      references: { index: "01", label: "Referenzen", title: "Unsere Referenzprojekte", sub: "Ausgewählte Projekte aus der Elektroplanung und technischen Projektbearbeitung." },
      about: { index: "04", label: "Über uns", title: "Über ArStudio Elektro" },
      contact: { index: "05", label: "Kontakt", title: "Kontaktieren Sie uns", sub: "Sie suchen einen zuverlässigen Partner für Ihre Elektroplanung? Kontaktieren Sie uns gerne für Ihr nächstes Projekt." },
    },
    services: [
      { title: "Analyse der Kundenanforderungen" },
      { title: "Steckdosenplan" },
      { title: "Schalterplan" },
      { title: "Beleuchtungsplan" },
      { title: "Stromkreisplan" },
      { title: "Verteilerplan" },
      { title: "Kabeldimensionierung & Schutzberechnungen" },
      { title: "Elektrische Berechnungen (Last, Spannungsfall, Selektivität u. a.)" },
      { title: "Einlinienschema" },
      { title: "Mengen- und Materiallisten" },
      { title: "Brandmeldeanlagen-Planung (BMA)" },
      { title: "Daten-/LAN- und Telekommunikationspläne" },
      { title: "Gegensprech- und Zutrittskontrollsysteme" },
      { title: "Videoüberwachung (CCTV)" },
      { title: "Elektrische Rollladenverkabelung" },
      { title: "Wärmepumpen-Anschlüsse" },
      { title: "Photovoltaik-Planung (PV), bei Bedarf" },
      { title: "E-Ladesäulen (Wallbox)" },
      { title: "Blitzschutz- und Erdungsplanung, bei Bedarf" },
    ],
    why: [
      "Professionelle Elektroplanung",
      "Erfahrung mit deutschen Bauprojekten",
      "Flexible Remote-Zusammenarbeit",
      "Präzise und strukturierte Planunterlagen",
      "Zuverlässige Kommunikation",
      "Unterstützung von der Planung bis zur Ausführungsplanung",
    ],
    whyCard: {
      title: "Planungspartner auf Augenhöhe",
      text: "Wir arbeiten als externes Planungsbüro direkt mit Architekten, Generalunternehmern und Ingenieurbüros zusammen — digital, strukturiert und termintreu.",
    },
    references: {
      viewProject: "Projekt ansehen",
      area: "Projektgröße",
      documents: "Projektunterlagen ansehen",
      contact: "Kontakt aufnehmen",
      detail: {
        location: "Standort",
        locationValue: "Deutschland",
        scopeLabel: "Leistungsumfang",
        processingLabel: "Bearbeitungsumfang",
        processingValue: "Grundlagen, elektrotechnische Schemata und Berechnungen",
        includedLabel: "Enthaltener Leistungsumfang",
        documentsLabel: "Projektunterlagen",
        included: [
          "Grundrisse der Elektroinstallation",
          "Beleuchtungsplanung",
          "Steckdosenplanung",
          "Stromkreisplanung",
          "Verteilungsplanung",
          "Kabel- und Leitungsplanung",
          "Verteiler- und Schaltschrankplanung",
          "Legenden und technische Details",
          "Elektrotechnische Berechnungen einschließlich Kabel- und Leitungsdimensionierung",
        ],
      },
    },
    about: {
      p1: "ArStudio Elektro ist ein Planungsbüro für Elektrotechnik und Elektroplanung. Wir unterstützen Architekturbüros, Generalunternehmer, Ingenieurbüros, Bauunternehmen und Projektentwickler in Deutschland — vollständig remote und digital.",
      p2: "Unser Fokus liegt auf präziser Elektroplanung, CAD- und BIM-basierter Ausführungsplanung sowie strukturierter technischer Dokumentation nach deutschen Projektstandards. Dabei legen wir besonderen Wert auf verlässliche Kommunikation, klare Planunterlagen und eine reibungslose Zusammenarbeit über alle Projektphasen.",
      chips: ["Elektroplanung", "CAD / BIM", "Ausführungsplanung", "Technische Dokumentation", "Remote-Zusammenarbeit", "Deutsche Projektstandards", "Zuverlässige Kommunikation"],
      statLabel: "Arbeitsweise",
      statValue: "100% Remote & digital",
    },
    contact: {
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      form: {
        name: "Name",
        company: "Unternehmen",
        email: "E-Mail",
        phone: "Telefon",
        message: "Projekt / Nachricht",
        submit: "Anfrage senden",
        sending: "Wird gesendet …",
        success: "Vielen Dank! Ihre Anfrage wurde übermittelt. Wir melden uns zeitnah bei Ihnen.",
        error: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt per E-Mail.",
        fallback: "Ihre Anfrage wurde vorbereitet — Ihr E-Mail-Programm wurde geöffnet. Bitte senden Sie die E-Mail ab.",
        required: "Bitte füllen Sie alle Pflichtfelder aus.",
      },
    },
    footer: {
      tagline: "Professionelle Elektroplanung für Bauprojekte in Deutschland",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      legalTitle: "Rechtliches",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      rights: "Alle Rechte vorbehalten.",
    },
    project: {
      back: "Zurück zu den Referenzen",
      location: "Standort",
      type: "Projektart",
      scope: "Leistungsbereich",
      responsible: "Bearbeitung",
      plans: "Ausführungspläne ansehen",
      plansNote: "Pläne folgen in Kürze",
      details: "Projektdetails",
      contact: "Kontakt aufnehmen",
      notFound: "Projekt nicht gefunden.",
    },
    legal: {
      back: "Zurück zur Startseite",
      placeholderNote: "Hinweis: Diese Seite ist ein Platzhalter und wird aktuell vorbereitet. Die rechtsverbindlichen Inhalte folgen in Kürze.",
      impressum: {
        title: "Impressum",
        blocks: [
          { heading: "Angaben gemäß § 5 TMG", body: "ArStudio Elektro\nElektroplanung & Elektrotechnik\n\nDie vollständigen Angaben werden derzeit vorbereitet und in Kürze ergänzt." },
          { heading: "Kontakt", body: "Telefon: +383 45 813 843\nE-Mail: info@ar-elektro.online" },
          { heading: "Verantwortlich für den Inhalt", body: "ArStudio Elektro\n\nDie Angaben werden derzeit vorbereitet und in Kürze ergänzt." },
        ],
      },
      datenschutz: {
        title: "Datenschutzerklärung",
        blocks: [
          { heading: "1. Verantwortliche Stelle", body: "Verantwortlich für die Datenverarbeitung auf dieser Website ist ArStudio Elektro. Die vollständige Datenschutzerklärung wird derzeit vorbereitet und in Kürze ergänzt." },
          { heading: "2. Erhebung und Verarbeitung von Daten", body: "Bei Nutzung des Kontaktformulars werden die angegebenen Daten (Name, Unternehmen, E-Mail, Telefon, Nachricht) zur Bearbeitung Ihrer Anfrage verarbeitet und gespeichert. Eine Weitergabe an Dritte erfolgt nicht." },
          { heading: "3. Ihre Rechte", body: "Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Wenden Sie sich hierzu an info@ar-elektro.online." },
        ],
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      references: "References",
      about: "About us",
      contact: "Contact",
      cta: "Request a project",
    },
    hero: {
      overline: "Electrical Planning · Electrical Engineering · Remote Engineering",
      lines: ["Professional electrical", "planning for construction", "projects in Germany"],
      sub: "Reliable planning, technical documentation and digital support for architecture firms, engineering offices, construction companies and property developers.",
      primary: "Request a project",
      secondary: "Our references",
      meta: ["Remote engineering for the German market", "Planning according to German project standards", "CAD / BIM based workflow"],
    },
    marquee: ["Electrical Planning", "Execution Planning", "Power Systems", "Low-Voltage Systems", "Lighting Design", "CAD & BIM", "Technical Documentation", "Remote Engineering"],
    sections: {
      services: { index: "02", label: "Services", title: "Our Services", sub: "Planning, documentation and technical support for construction projects of any scale." },
      why: { index: "03", label: "Why us", title: "Why ArStudio Elektro?", sub: "A reliable planning partner for the German construction market." },
      references: { index: "01", label: "References", title: "Our Reference Projects", sub: "Selected projects from electrical planning and technical project processing." },
      about: { index: "04", label: "About us", title: "About ArStudio Elektro" },
      contact: { index: "05", label: "Contact", title: "Get in touch", sub: "Looking for a reliable partner for your electrical planning? Feel free to contact us for your next project." },
    },
    services: [
      { title: "Client requirements analysis" },
      { title: "Socket layout (Steckdosenplan)" },
      { title: "Switch layout (Schalterplan)" },
      { title: "Lighting layout (Beleuchtungsplan)" },
      { title: "Electrical circuit plans (Stromkreisplan)" },
      { title: "Distribution board / panel layouts (Verteilerplan)" },
      { title: "Cable sizing & protection calculations" },
      { title: "Electrical calculations (load, voltage drop, selectivity, etc.)" },
      { title: "Single-line diagrams (Einlinienschema)" },
      { title: "Bill of quantities & material lists" },
      { title: "Fire alarm system design (BMA)" },
      { title: "Data/LAN & telecommunications layouts" },
      { title: "Intercom & access control systems" },
      { title: "CCTV system layouts" },
      { title: "Electric roller shutter wiring" },
      { title: "Heat pump electrical connections" },
      { title: "Photovoltaic (PV) system design, where required" },
      { title: "EV charging stations (Wallbox)" },
      { title: "Lightning protection & earthing design, where required" },
    ],
    why: [
      "Professional electrical planning",
      "Experience with German construction projects",
      "Flexible remote collaboration",
      "Precise and structured planning documents",
      "Reliable communication",
      "Support from planning through execution planning",
    ],
    whyCard: {
      title: "A planning partner at eye level",
      text: "We work as an external planning office directly with architects, general contractors and engineering firms — digital, structured and on schedule.",
    },
    references: {
      viewProject: "View project",
      area: "Area",
      documents: "View project documents",
      contact: "Get in touch",
      detail: {
        location: "Location",
        locationValue: "Germany",
        scopeLabel: "Scope of services",
        processingLabel: "Processing scope",
        processingValue: "Fundamentals, electrical schematics and calculations",
        includedLabel: "Included scope of services",
        documentsLabel: "Project documents",
        included: [
          "Electrical installation floor plans",
          "Lighting planning",
          "Socket planning",
          "Circuit planning",
          "Distribution planning",
          "Cable and wiring planning",
          "Distribution board and cabinet planning",
          "Legends and technical details",
          "Electrical calculations incl. cable and wire sizing",
        ],
      },
    },
    about: {
      p1: "ArStudio Elektro is a planning office for electrical engineering and electrical planning. We support architecture firms, general contractors, engineering offices, construction companies and property developers in Germany — fully remote and digital.",
      p2: "Our focus is on precise electrical planning, CAD and BIM based execution planning, and structured technical documentation according to German project standards. We place particular emphasis on reliable communication, clear planning documents and smooth collaboration across all project phases.",
      chips: ["Electrical planning", "CAD / BIM", "Execution planning", "Technical documentation", "Remote collaboration", "German project standards", "Reliable communication"],
      statLabel: "Workflow",
      statValue: "100% remote & digital",
    },
    contact: {
      phoneLabel: "Phone",
      emailLabel: "Email",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        message: "Project / Message",
        submit: "Send inquiry",
        sending: "Sending …",
        success: "Thank you! Your inquiry has been submitted. We will get back to you shortly.",
        error: "Your inquiry could not be sent. Please try again or email us directly.",
        fallback: "Your inquiry has been prepared — your email client has been opened. Please send the email.",
        required: "Please fill in all required fields.",
      },
    },
    footer: {
      tagline: "Professional electrical planning for construction projects in Germany",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legalTitle: "Legal",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      rights: "All rights reserved.",
    },
    project: {
      back: "Back to references",
      location: "Location",
      type: "Project type",
      scope: "Scope of services",
      responsible: "Executed by",
      plans: "View execution plans",
      plansNote: "Plans coming soon",
      details: "Project details",
      contact: "Get in touch",
      notFound: "Project not found.",
    },
    legal: {
      back: "Back to homepage",
      placeholderNote: "Note: This page is a placeholder and is currently being prepared. The legally binding content will follow shortly.",
      impressum: {
        title: "Imprint",
        blocks: [
          { heading: "Information according to § 5 TMG", body: "ArStudio Elektro\nElectrical Planning & Engineering\n\nFull details are currently being prepared and will be added shortly." },
          { heading: "Contact", body: "Phone: +383 45 813 843\nEmail: info@ar-elektro.online" },
          { heading: "Responsible for content", body: "ArStudio Elektro\n\nDetails are currently being prepared and will be added shortly." },
        ],
      },
      datenschutz: {
        title: "Privacy Policy",
        blocks: [
          { heading: "1. Responsible entity", body: "ArStudio Elektro is responsible for data processing on this website. The full privacy policy is currently being prepared and will be added shortly." },
          { heading: "2. Collection and processing of data", body: "When using the contact form, the data provided (name, company, email, phone, message) is processed and stored to handle your inquiry. No data is shared with third parties." },
          { heading: "3. Your rights", body: "You have the right to access, rectification, deletion and restriction of processing of your personal data at any time. Contact info@ar-elektro.online." },
        ],
      },
    },
  },
};
